import { createFileRoute } from "@tanstack/react-router";
import { DeletedPage } from "../../components/pages/deleted";
import { searchNumber, searchString } from "../../lib/search";

interface DeletedSearch {
  app?: string;
  trashDays?: number;
  owner?: boolean;
}

/** 10b. The API's handoff redirects here: /deleted?app=<slug>&trashDays=<n>&owner=1|0 */
export const Route = createFileRoute("/_authed/deleted")({
  validateSearch: (search: Record<string, unknown>): DeletedSearch => {
    const out: DeletedSearch = {};
    const app = searchString(search.app);
    const trashDays = searchNumber(search.trashDays);
    if (app !== undefined) out.app = app;
    if (trashDays !== undefined) out.trashDays = trashDays;
    if (search.owner === 1 || search.owner === "1" || search.owner === true) out.owner = true;
    return out;
  },
  component: DeletedRoute,
});

function DeletedRoute() {
  const { app, trashDays, owner } = Route.useSearch();
  return <DeletedPage slug={app ?? null} trashDays={trashDays ?? null} isOwner={owner === true} />;
}
